import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oil-gas',
  templateUrl: './oil-gas.component.html',
  styleUrls: ['./oil-gas.component.css']
})
export class OilGasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
